import React, { Component } from 'react';
import { getUserAuditLogsData, getRoles } from './UserAuditLogs.actions';
import UserAuditLogsView from './UserAuditLogsView';
import Utils from '../../../common/utils/Utils';
import moment from 'moment';
import Constants from '../../../common/constants/Constants';
import { withRouter, getQueryParam, setQueryParam } from '../../../common/utils/NavigationWrapper';

const formatJson = (el, col, elIndex, colIndex) => {
  let value = el[col.key];

  if (typeof value !== 'string' || value[0] !== '{') {
    return <div>{value}</div>;
  }

  let entity = JSON.parse(value);
  let listItems = Object.keys(entity).map((key) => {
    return (
      <li>
        {key} = {JSON.stringify(entity[key])}
      </li>
    );
  });

  return (
    <div>
      <ul>{listItems}</ul>
    </div>
  );
};

class UserAuditLogsContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tableData: [],
      dateFrom: moment.utc().subtract(1, 'days'),
      dateTo: moment.utc(),
      isFetching: true,
      metadata: {},
      columnsConfig: [
        {
          name: 'Date',
          key: 'Date',
          type: 'datetime',
          style: { width: '12rem' },
          visible: true,
          filterable: true,
          sortable: true,
        },
        {
          name: 'User name',
          key: 'Username',
          type: 'string',
          visible: true,
          filterable: true,
          sortable: true,
        },
        {
          name: 'Role',
          key: 'RoleName',
          type: 'string',
          style: { width: '8rem' },
          visible: true,
          filterable: true,
          sortable: true,
        },
        {
          name: 'Context',
          key: 'TransactionName',
          type: 'string',
          style: { width: '15rem' },
          visible: true,
          filterable: true,
          sortable: true,
        },
        {
          name: 'Action',
          key: 'Action',
          type: 'string',
          style: { width: '8rem' },
          visible: true,
          filterable: true,
          sortable: true,
        },
        {
          name: 'Table name',
          key: 'TableName',
          type: 'string',
          visible: true,
          filterable: true,
          sortable: true,
        },
        {
          name: 'Primary key',
          key: 'PrimaryKey',
          type: 'string',
          style: { width: '8rem' },
          visible: true,
          filterable: true,
          sortable: true,
        },
        {
          name: 'Parameter name',
          key: 'ColumnName',
          type: 'string',
          visible: true,
          filterable: true,
          sortable: true,
        },
        {
          name: 'New value',
          key: 'NewValue',
          type: 'markup',
          markup: formatJson,
          style: { width: '20rem' },
          visible: true,
          filterable: true,
          sortable: true,
        },
        {
          name: 'Old value',
          key: 'OldValue',
          type: 'markup',
          markup: formatJson,
          style: { width: '20rem' },
          visible: true,
          filterable: true,
          sortable: true,
        },
      ],
      dateTimeErrorMessage: null,
    };

    this._onChangeDateTime = this._onChangeDateTime.bind(this);
  }

  componentDidMount() {
    const dateFrom = getQueryParam('dateFrom', 'customDateTimeType', this.props.querySearchParams);
    const dateTo = getQueryParam('dateTo', 'customDateTimeType', this.props.querySearchParams);

    const newDateFrom = this._determinePropertyValue(dateFrom, 'dateFrom');
    const newDateTo = this._determinePropertyValue(dateTo, 'dateTo');
    const dateTimeErrorMessage = this._checkDateTimeCorrectness(newDateFrom, newDateTo);
    this.setState(
      {
        dateFrom: newDateFrom,
        dateTo: newDateTo,
        dateTimeErrorMessage,
      },
      () => {
        this._getData(this.state.dateFrom, this.state.dateTo);
      }
    );
  }

  render() {
    return (
      <UserAuditLogsView
        tableData={this.state.tableData}
        dateFrom={this.state.dateFrom}
        dateTo={this.state.dateTo}
        isFetching={this.state.isFetching}
        columnsConfig={this.state.columnsConfig}
        onChangeTable={this._onChangeTable}
        onChangeDateTime={this._onChangeDateTime}
        onApplyFilters={this._onApplyFilters}
        metadata={this.state.metadata}
        instrument={this.props.instrument}
        dateTimeErrorMessage={this.state.dateTimeErrorMessage}
      />
    );
  }

  _determinePropertyValue = (propertyValue, propertyNameInState) => {
    return propertyValue != null ? propertyValue : this.state[propertyNameInState];
  };

  _checkDateTimeCorrectness = (dateFrom, dateTo) => {
    let dateTimeErrorMessage;
    if (moment(dateFrom).isAfter(dateTo)) {
      dateTimeErrorMessage = Constants.DATEFROM_AFTER_DATETO_ERROR_MESSAGE;
    }

    if (moment(dateTo).isBefore(dateFrom)) {
      dateTimeErrorMessage = Constants.DATETO_BEFORE_DATEFROM_ERROR_MESSAGE;
    }

    return dateTimeErrorMessage;
  };

  _onChangeDateTime = (key, date) => {
    let dateTimeErrorMessage = null,
      newDateFrom = null,
      newDateTo = null;

    switch (key) {
      case 'dateFromFilter': {
        newDateFrom = date;
        newDateTo = this.state.dateTo;
        break;
      }
      case 'timeFromFilter': {
        newDateFrom = date;
        newDateTo = this.state.dateTo;
        break;
      }
      case 'dateToFilter': {
        newDateTo = date;
        newDateFrom = this.state.dateFrom;
        break;
      }
      case 'timeToFilter': {
        newDateTo = date;
        newDateFrom = this.state.dateFrom;
        break;
      }
      default:
        break;
    }

    newDateFrom.set({ second: 0, millisecond: 0 });
    newDateTo.set({ second: 0, millisecond: 0 });

    dateTimeErrorMessage = this._checkDateTimeCorrectness(newDateFrom, newDateTo);

    this.setState({ dateFrom: newDateFrom, dateTo: newDateTo, dateTimeErrorMessage }, () => {
      let newQueryParams = [
        {
          value: newDateFrom,
          key: 'dateFrom',
          type: 'customDateTimeType',
        },
        {
          value: newDateTo,
          key: 'dateTo',
          type: 'customDateTimeType',
        },
      ];

      setQueryParam(newQueryParams, this.props.querySearchParams, this.props.setQuerySearchParams);
    });
  };

  _onApplyFilters = () => {
    this.setState({ isFetching: true });

    this._getData(this.state.dateFrom, this.state.dateTo);
  };

  _getData(dateFrom, dateTo) {
    const start = Utils.FeDateAsUtcForBeISOString(moment(dateFrom).startOf('minute'));
    const end = Utils.FeDateAsUtcForBeISOString(moment(dateTo).startOf('minute'));

    Promise.all([getUserAuditLogsData(start, end), getRoles()])
      .then((allResp) => {
        const data = allResp[0].body;

        const roles = {};
        allResp[1].body.forEach((role) => (roles[role.RoleEntityId] = role.Name));
        data.Table.forEach((el) => (el.RoleName = roles[el.RoleEntityId]));

        this.setState({
          tableData: data.Table,
          isFetching: false,
          metadata: data.Metadata,
        });
      })
      .catch((e) =>
        this.setState({
          isFetching: false,
        })
      );
  }
}

export default withRouter(UserAuditLogsContainer);
